exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blur-high-risk[data-v-4270a78e] {\r\n  -webkit-filter: blur(25px);\r\n          filter: blur(25px)\n}\n.blur-high-risk[data-v-4270a78e]:active {\r\n  -webkit-filter: none;\r\n          filter: none;\n}\r\n\r\n/* iOS 18.3 introduced a bug where z-index would get set to -1 and the image dissapears after a few seconds.  This fixes that.*/\n[data-v-4270a78e] .v-image__image.v-image__image--contain {\r\n  z-index: 0 !important;\n}\r\n\r\n", ""]);

// exports
